import CustButton from "../components/CustButton";
import { useEffect } from "react";

const NotFoundPage = ({ handleClose }) => {
    useEffect(() => {
      const timeoutId = setTimeout(() => {
        handleClose();
      }, 1000);
  
      return () => clearTimeout(timeoutId);
    }, [handleClose]);
  
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        height: "100vh"
      }}>
        <h1>404</h1>
        <h3>Page Not Found</h3>
        <CustButton path={"/"} text="Back to Home" />
      </div>
    );
  };

export default NotFoundPage;